module.exports = __webpack_public_path__ + "static/media/hello.2226cf5e.png";